import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
const initialState = {
	// specialistList: [],
	// specialistDetails: [],
	// experienceList: {},
	// subSpecializationList: [],
	dashSpecializationList: [],
	appointmentsCount: []
};

export default function dashboardReducer(state = [], action) {
	switch (action.type) {
		case types.DASH_GET_SPECIALIZATION_LIST:
			return objectAssign({}, state, {
				dashSpecializationList: action.specializationList
			});
		case types.GET_APPOINTMENTS_COUNT:
			return objectAssign({}, state, {
				appointmentsCount: action.appointmentsCount
			});
			case types.GET_USER_DETAILS_FOR_IMAGE:
			return objectAssign({}, state, {
				userDetails: action.userDetails
			});
		default:
			return state;
	}
}